/**
 * Created by MateuszWaligora on 14.07.2017.
 */
/* eslint-disable */
import Vue from 'vue';
import objectPath from 'object-path';
import * as VueDeepSet from 'vue-deepset';
import { utils } from '../../plugins/utils';
import {HTTPCODES} from '../../plugins/types';

/**
 * @module Store/view
 * @description Module for products
 */

/**
 * @constant State of orders store
 * @type {object}
 * */
const state = {
    currentLayout: {},
    layouts: [],
    editedElement: {},
    editedElementRootPath: '',
    currentScale: 1,
    editedElementId: '',
    uidKey: 'asda'
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getLayouts: state => {
        return state.layouts;
    },
    getCurrentLayout: state => {
        return state.currentLayout;
    },
    getEditedElement: state => {
        return state.editedElement;
    },
    getEditedElementRootPath: state => {
        return state.editedElementRootPath;
    },
    getEditedElementId: state => {
        return state.editedElementId;
    },
    getScale: state => {
        return state.currentScale;
    },
    getParsedScale: state => {
        return `scale(${state.currentScale})`;
    },
    getUid: state => {
        return state.uidKey;
    }
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = VueDeepSet.extendMutation({
    updateLayouts: (state, layouts) => {
        state.layouts = layouts;
    },
    updateCurrentLayout: (state, layout) => {
        state.currentLayout = {...layout};
    },
    updateEditedElement: (state, element) => {
        state.editedElement = {...element};
    },
    updateEditedElementRootPath: (state, path) => {
        state.editedElementRootPath = path;
    },
    updateMetadata: (state, metadata) => {
        state.currentLayout.metadata = metadata;
    },
    updateScale: (state, scale) => {
        state.currentScale = scale;
    },
    generateNewUid: (state) => {
        state.uidKey = utils.shortid.generate();
    },
    removeMetadataValue: (state, payload) => {
        if(state.currentLayout.metadata.scalableValues) {
            if(state.currentLayout.metadata.scalableValues.length > 0) {
                state.currentLayout.metadata.scalableValues.splice(payload.index, 1);
            }
        }
    },
    resetLayout: (state) => {
        state.currentLayout = {"tag": "div",
            "attrs": {
                "style": {
                    "width": "320px",
                    "height": "480px",
                    "padding": "0",
                    "margin": "0",
                    "background-color": "transparent",
                    "color": "black",
                    "box-sizing": "border-box"
                },
                "domProps": {
                    "id": "body",
                    draggable: false
                }
            },
            "metadata":{
                "format":[
                    {
                        "pathWidth":"$.attrs.style.width",
                        "pathHeight":"$.attrs.style.height"
                    }
                ],
                "source":[

                ],
                "template":{
                    "path":"$.children"
                }
            },
            "children": [
                {
                    "tag": "div",
                    "attrs": {
                        "style": {
                            "width": "100%",
                            "height": "100%",
                            "position": "relative",
                            "background-color": "#fff"
                        },
                        "domProps": {
                            "id": utils.shortid.generate(),
                            draggable: false
                        }
                    },
                    "children": []

                }
            ]
        }
    },
    //TODO SWAP OR REMOVE DUPLICATES
    updateMetaData: (state, {src, toDelete}) => {
        let itemId = state.editedElementId;
        let found = false;
        let foundIndex = 0;
        state.currentLayout.metadata.source.forEach((source, index) => {
            if(source.id === itemId)  {
                found = true;
                foundIndex = index;
            }
        });
        if(!found && itemId && !toDelete) {
            let newObj = {
                id: itemId,
                attrs: `style['background-image']`,
                url: true
            };
            // state.currentLayout.metadata.source.push(newObj);
        } else {
            state.currentLayout.metadata.source.splice(foundIndex, 1);
        }
    },

    addMetaData: (state, {id, src, dontAdd, url}) => {
        if(dontAdd) {
            return;
        }
        if(!state.currentLayout.metadata.source) {
            state.currentLayout.metadata = [];
        }
        state.currentLayout.metadata.source.push({
            id: id,
            attrs: `style['background-image']`,
            url: true
        });
    },
    deleteMetadataSource: (state, foundIndex) => {
        state.currentLayout.metadata.source.splice(foundIndex, 1);
    },
    setEditedElementId: (state, editedElementId) => {
        state.editedElementId = editedElementId;
    },

    addTemplateToLayout: (state, templateId) => {
        if(state.currentLayout.availableTemplates) {
            state.currentLayout.availableTemplates.push({templateId: templateId});
        } else {
            state.currentLayout.availableTemplates = [{templateId: templateId}];
        }
    },
    setAvailableTemplates: (state, templates) => {
        if(!state.currentLayout.availableTemplates) {
            state.currentLayout.availableTemplates = [];
        }
        state.currentLayout.availableTemplates = [...state.currentLayout.availableTemplates, ...templates].filter(utils.onlyUniqueItems);
    },
    clearTemplates: (state) => {
        state.currentLayout.availableTemplates = [];
    },
    updateTemplates: (state, templates) => {
        state.currentLayout.availableTemplates = templates;
    },
    removeTemplateFromCurrentLayout: (state, index) => {
        if(state.currentLayout.availableTemplates.length >= 1) {
            state.currentLayout.availableTemplates.splice(index, 1);
        }
    }
});

/** TODO
 * 1. Add list of available formats to layout in template editor
 * 2. Filter available layouts in product addition / edition depending on selected format
 */
/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async addLayoutAsync ({dispatch, commit, rootState}, {layout, disableFetch = false}) {
        let id = utils.shortid.generate();
        let body = {
            ...clearEditableFields(layout),
            format: {
                width: +layout.format.width,
                height: +layout.format.height
            },
            id: id
        };
        try {
            let {data} = await Vue.axios.post(`${rootState.config.templatePort}/layout?scale=1`, body);
            if(!disableFetch) {
                dispatch('fetchLayoutsAsync');
            }
            if(layout.jsonData.availableFormats) {
                dispatch('addFormatListToLayout', {id: data.id, formats: layout.jsonData.availableFormats});
            }
            return {id: data.id, oldId: layout.id};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to add layout'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('updateLayouts', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'to add new layout'
            });
            throw new Error(err);
        }
    },
    async putLayoutAsync ({dispatch, commit, rootState}, {id, jsonData, disableFetch = false}) {
        let body = clearEditableFields(jsonData);
        try {
            let res = await Vue.axios.put(`${rootState.config.templatePort}/layout/${id}/json?scale=1`, body);
            if(!disableFetch) {
                dispatch('fetchLayoutsAsync');
            }
            if(body.availableFormats) {
                dispatch('addFormatListToLayout', {id: id, formats: body.availableFormats});
            }
            return res;
        } catch (err){
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to update layout'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to update layout ${id}`
            });
            throw new Error(err);
        }

    },
    async addFormatListToLayout ({commit, rootState}, {id, formats}) {
        const body = {
            format: formats.map(format => format.id)
        };
        try {
            let res = await Vue.axios.post(`${rootState.config.templatePort}/layout/${id}/format`, body);
            return res;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to add format list to layout'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to add format list to layout: ${id}`
            });
            throw new Error(err);
        }
    },
    async getLayoutAsync ({commit, rootState}, {layout}) {
        try {
            let res = await Vue.axios.get(`${rootState.config.templatePort}/layout/${layout.id}/json?scale=1`);
            return res;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to get layout: ${layout.id}`
            });
            throw new Error(err);
        }
    },
    async getLayoutsWithFormatId ({commit, rootState}, {id}) {
        const options = {
            params: {
                format: id
            }
        };
        try {
            let {data} = await Vue.axios.get(`${rootState.config.templatePort}/layout/format`, options);
            return {data};
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to get layouts for format: ${id}`
            });
            throw new Error(err);
        }
    },
    async deleteLayoutAsync ({commit, rootState, dispatch}, {id, disableDispatch = false}) {
        try {
            return await Vue.axios.delete(`${rootState.config.templatePort}/layout/${id}`);
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    commit('addAlert', {
                        title: 'Unauthorized ',
                        type: 'danger',
                        body: 'to delete layout'
                    });
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: `to delete layout: ${id}`
            });
            throw new Error(err);
        } finally {
            if(!disableDispatch) {
                dispatch('fetchLayoutsAsync');
            }
        }
    },
    async fetchLayoutsAsync ({commit, rootState}) {
        try {
            let res = await Vue.axios.get(`${rootState.config.templatePort}/layout/`);
            commit('updateLayouts', res.data);
            return res;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('updateLayouts', []);
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'get layouts collection'
            });
            throw new Error(err);
        }
    },
    clearEditedElement ({commit}) {
        commit('setEditedElementId', '');
        commit('updateEditedElement', {});
    },
    updateEditedElementAction ({commit, dispatch, state}, {path, element}) {
        commit('updateEditedElementRootPath', path);
        dispatch('updateEditedElementIdAction', element);
        commit('updateEditedElement', element);
    },
    updateEditedElementIdAction ({commit}, element) {
        let id = '';
        if(element) {
            if(element.hasOwnProperty('attrs')) {
                if(element.attrs.hasOwnProperty('domProps')) {
                    id = element.attrs.domProps.id;
                    commit('setEditedElementId', id);
                }
            }
        }
    },
    getEditedElementParent ({commit, dispatch, state}, {path}) {
        let parentsPath = path.split('.');
        if(parentsPath.length >= 2) {
            parentsPath.pop();
            parentsPath.pop();
        }
        parentsPath =  parentsPath.join('.');
        var newEditedElement = objectPath.get(state.currentLayout, parentsPath);
        dispatch('updateEditedElementIdAction', newEditedElement);
        commit('updateEditedElementRootPath', parentsPath);
        commit('updateEditedElement', newEditedElement);
    },
    getEditedElementChild ({commit, dispatch, state}, {path}) {
        let childPath = path + '.children.0';
        if(childPath.startsWith('.')) {
            childPath = childPath.substr(1, childPath.length - 1);
        }
        var newEditedElement = objectPath.get(state.currentLayout, childPath);
        if(newEditedElement) {
            dispatch('updateEditedElementIdAction', newEditedElement);
            commit('updateEditedElementRootPath', childPath);
            commit('updateEditedElement', newEditedElement);
            return true;
        }
    },
    getEditedElementSibling ({commit, dispatch, state}, {path, prevOrNext}) {
        let siblingsPath = path.split('.');
        let siblingIndex = +(siblingsPath[siblingsPath.length - 1]);
        siblingIndex += prevOrNext === 'prev' ? -1 : 1;
        if(siblingIndex < 0) {
            siblingIndex = 0;
        }
        siblingsPath[siblingsPath.length - 1] = siblingIndex;
        siblingsPath = siblingsPath.join('.');

        if(objectPath.has(state.currentLayout, siblingsPath)) {
            var newEditedElement = objectPath.get(state.currentLayout, siblingsPath);
            dispatch('updateEditedElementIdAction', newEditedElement);
            commit('updateEditedElementRootPath', siblingsPath);
            commit('updateEditedElement', newEditedElement);

        }
    },
    async updateLayoutAsync ({state, rootState}) {
        try {
            return await Vue.axios.post(`${rootState.config.templatePort}${rootState.config.templatePort}`, state.currentLayout);
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                return {err: HTTPCODES[err.response.status]};
            }
        }
    },
    changeLayoutFormat ({commit, state}, {height, width}) {
        let currentLayout = {...state.currentLayout};
        currentLayout.attrs.style.height = height + 'px';
        currentLayout.attrs.style.width = width + 'px';
        commit('updateCurrentLayout', currentLayout);
    },
    addElementAction ({commit, state}, {path, oldPath, value}) {
        let currentLayout = {...state.currentLayout};
        let split = path.split('.');
        let lastElement = split.length - 1;
        if(typeof +split[lastElement] === 'number') {
            split.push('children')
        }
        path = split.join('.');
        if (path.startsWith(oldPath) && oldPath.length > 0) {
            objectPath.set(currentLayout, oldPath, value);
        } else {
            objectPath.push(currentLayout, path, value);
            if(oldPath) {
                objectPath.del(currentLayout, oldPath);
            }
        }

        commit('updateCurrentLayout', currentLayout);
        commit('addMetaData', {
            id: value.attrs.domProps.id,
            src: `style['background-image']`,
            url: true,
            dontAdd: oldPath !== '' || !value.isImage
        });
        commit('generateNewUid');
    },
    //DESTROYS ELEMENT WHEN DROPPED OVER REMOVE BIN
    destroyElement ({commit, dispatch, state}, {oldPath}) {
        let currentLayout = state.currentLayout;
        dispatch('deleteMetadataAction', objectPath.get({...state.currentLayout}, oldPath));
        objectPath.del(currentLayout, oldPath);
        commit('updateCurrentLayout', currentLayout);
        commit('generateNewUid');
    },
    deleteMetadataAction ({commit, dispatch, state}, element) {
        if(element && element.hasOwnProperty('attrs')) {
            if(element.attrs.hasOwnProperty('domProps')) {
                let id = element.attrs.domProps.id || '';
                let found = false;
                let foundIndex = 0;
                state.currentLayout.metadata.source.forEach((source, index) => {
                    if(source.id === id)  {
                        found = true;
                        foundIndex = index;
                    }
                });
                if(found) {
                    commit('deleteMetadataSource', foundIndex);
                    if(element.hasOwnProperty('children')) {
                        element.children.forEach(child => {
                            dispatch('deleteMetadataAction', child);
                        })
                    }
                }
            }
        }
    },
    getElementFromSchema ({state, rootState}, element) {
        return objectPath.get(state.currentLayout, element);
    },

    async postTemplate ({commit, dispatch, rootState}, {file, template, active, update}) {
        let body = new FormData();
        body.append('file', file);
        body.append('tags', template.tags);
        body.append('description', template.name);
        try {
            let {data} = await Vue.axios.post(`${rootState.config.templatePort}/template${update ? '/' + template.id : ''}`, body);
            if(active) {
                commit('addTemplateToLayout', data.id);
            } else {
                dispatch('removeTemplateFromLayout', template);
            }
        } catch (err) {
            console.log(err);
        }
    },
    removeTemplateFromLayout ({commit, state}, template) {
        if(state.currentLayout.hasOwnProperty('availableTemplates')) {
            state.currentLayout.availableTemplates.forEach((item, index) => {
                if(!template.active && item.templateId === template.id) {
                    commit('removeTemplateFromCurrentLayout', index);
                }
            });
        }
    }


};

export default {
    state,
    getters,
    mutations,
    actions
};

function clearEditableFields (data) {
    let keypaths = utils.getNestedKeyPaths(data, 'editable');
    if(keypaths.found) {
        for(let index in keypaths.resultArray) {
            keypaths.resultArray[index].path.pop();
            let path = keypaths.resultArray[index].path;
            let newObj = objectPath.get(data, path);
            newObj.value = '';
            objectPath.set(data, path, newObj);
        }
    }
    return data;
}
